import { render, staticRenderFns } from "./TranCodePicker.vue?vue&type=template&id=83231660&scoped=true"
import script from "./TranCodePicker.vue?vue&type=script&lang=js"
export * from "./TranCodePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83231660",
  null
  
)

export default component.exports